import type { ApiError } from '@/shared/api';

/** Ohne Antwort ist offen, ob der Server übernommen hat — das darf keine Meldung als „nein“ ausgeben. */
export const unanswered = (problem: ApiError) => problem.status === 0;

/**
 * Warum der Server eine Änderung am Katalog nicht übernommen hat, in Worten für den Betreiber.
 * Servertexte bleiben draußen: sie sind englisch und bei Serverfehlern nichtssagend.
 */
export function problemReason(problem: ApiError, rejected: string) {
  if (problem.status === 409)
    return 'Die Nachrichten wurden inzwischen an anderer Stelle geändert.';
  if (problem.status === 403) {
    // Lesen und Vorschau reichen für einen Teil der Apartments, Ändern verlangt das ganze Objekt.
    return 'Dafür fehlt Ihnen die Berechtigung – Nachrichten ändert, wer alle Apartments dieses Objekts verwaltet.';
  }
  if (unanswered(problem)) {
    return 'Keine Antwort vom Server – ob die Änderung angekommen ist, ist offen. Bitte prüfen Sie die Verbindung.';
  }
  if (problem.status >= 500) {
    return 'Der Server konnte die Änderung gerade nicht übernehmen. Bitte versuchen Sie es erneut.';
  }
  return rejected;
}

/** Warum es keine neue Vorschau gibt — und ob ein zweiter Versuch etwas ändern kann. */
export function previewProblem(problem: ApiError) {
  if (unanswered(problem)) {
    return { reason: 'Keine Antwort vom Server. Bitte prüfen Sie die Verbindung.', retry: true };
  }
  if (problem.status >= 500) {
    return { reason: 'Der Server konnte diese Fassung gerade nicht erzeugen.', retry: true };
  }
  if (problem.status === 403) {
    return { reason: 'Für die Vorschau fehlt Ihnen die Berechtigung.', retry: false };
  }
  return {
    reason: 'Der Server lehnt diese Fassung ab. Prüfen Sie Felder, Zeilenumbrüche und Längen.',
    retry: false,
  };
}
